/**
 * @description 公共布局及样式自动引入
 */
import 'vant/es/toast/style';
import 'vant/es/dialog/style';

export function loadPlugins() {
    //const components = require.context('@/components', true, /\.vue$/)
    //components.keys().forEach((fileName) => {
    //    const componentConfig = components(fileName)
    //    const componentName = componentConfig.default.name
    //    app.component(componentName, componentConfig.default || componentConfig)
    //})
}

const requireThemes = require.context('@/styles', true, /\.less/)
requireThemes.keys().forEach((fileName) => {
    require(`@/styles/${fileName.slice(2)}`)
})
